import { POSITION, useToast } from 'vue-toastification';
import HtmlFormatter from '@/shared/services/htmlFormatter';

export default class Toast {
  public static showSuccess(message: string): void {
    const toast = useToast();

    toast.success(HtmlFormatter.escapeHtmlCharacters(message), {
      position: POSITION.BOTTOM_CENTER,
      timeout: 3_000,
      toastClassName: 'toast-success',
      hideProgressBar: true,
    });
  }

  public static showError(message: string): void {
    const toast = useToast();

    toast.error(HtmlFormatter.escapeHtmlCharacters(message), {
      position: POSITION.BOTTOM_CENTER,
      timeout: 3_000,
      toastClassName: 'toast-error',
      hideProgressBar: true,
    });
  }

  public static showInfo(message: string): void {
    const toast = useToast();

    toast.info(HtmlFormatter.escapeHtmlCharacters(message), {
      position: POSITION.BOTTOM_CENTER,
      timeout: 3_000,
      toastClassName: 'toast-info',
      hideProgressBar: true,
    });
  }
}
